import {useMemo, useState, useEffect} from 'react'
import {RequireLoginElement} from '@binance/uikit'
import useRouter from 'hooks/useRouter'
import {LOGIN_PRURL, REGISTER_URL} from 'constants'

const RequireLoginEl = ({i18n}) => {
  const [loginUrl, setLoginUrl] = useState('')
  const router = useRouter()
  const {lng = 'en'} = router.query

  useEffect(() => {
    setLoginUrl(`${LOGIN_PRURL}?callback=${window.location.href}`.replace('$locale', lng))
  }, [lng])
  return useMemo(
    () => (
      <RequireLoginElement
        i18n={i18n}
        loginUrl={loginUrl}
        registerUrl={REGISTER_URL.replace('$locale', lng)}
      />
    ),
    [i18n, lng, loginUrl]
  )
}

export default RequireLoginEl
